module.exports = __webpack_public_path__ + "img/portfolio.173ae2ba.webp";